import KategoriAnggotaService from "../../services/keanggotaan/kategori-anggota.service";

export const KategoriAnggota = {
  data() {
    return {
      optionKategoriAnggota : [],
      optionKategoriAnggotaFilter : [],
      multi_kategori_anggota: [],
      items_kategori_anggota : [],
      items_kategori_anggota_filter : [],
    };
  },
  methods: {
    getAllKategoriAnggota() {
        KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
            this.optionKategoriAnggota = response.data.data.content
            this.items_kategori_anggota = response.data.data.content 
        }).catch(error => {
            // comment console console.log(error)
        })
    },
    getAllKategoriAnggotaFilter() {
        KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
            this.optionKategoriAnggotaFilter = response.data.data.content
            var data = {
              namaKategori : "Belum Memiliki Kategori Anggota",
              idKategoriAnggota : "kategori_kosong"
            }
            this.optionKategoriAnggotaFilter.unshift(data);
            var data = {
              namaKategori : "Belum Memiliki No Anggota",
              idKategoriAnggota : "no_anggota_kosong"
            }
            this.optionKategoriAnggotaFilter.unshift(data);
            this.items_kategori_anggota_filter = response.data.data.content 
        }).catch(error => {
            // comment console console.log(error)
        })
    }
  }
};